import CONSTANT from "../constant/constant";
import { leaveConfigConstants } from "../constant/leaveConfig.constants";

export const initialState = {
    listConfig: {},
    errorCode: "",
    successCode: "",
    isLoading: false,
    updating: false,
};
const leaveConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case leaveConfigConstants.GET_CONFIG_LIST_SUCCESS:
            return {
                ...state,
                listConfig: action.list,
            };
        case leaveConfigConstants.UPDATE_CONFIG_LIST:
            return {
                ...state,
                updating: true,
            };
        case leaveConfigConstants.UPDATE_CONFIG_LIST_SUCCESS:
            return {
                ...state,
                updating: false,
                listConfig: action.newList,
                successCode: CONSTANT.messageCode.success,
            };
        case leaveConfigConstants.UPDATE_CONFIG_LIST_FAIL:
            return {
                ...state,
                updating: false,
                errorCode: action.error,
            };
        case leaveConfigConstants.CLEAR_MESSAGE:
            return {
                ...state,
                updating: false,
                errorCode: "",
                successCode: "",
            };
        default:
            return state;
    }
};

export default leaveConfigReducer;
